"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var react_dnd_1 = require("react-dnd");
var expand_more_1 = __importDefault(require("material-ui/svg-icons/navigation/expand-more"));
var expand_less_1 = __importDefault(require("material-ui/svg-icons/navigation/expand-less"));
var storage_1 = __importDefault(require("material-ui/svg-icons/device/storage"));
var IconButton_1 = __importDefault(require("../IconButton"));
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var utils_2 = require("../../../utils");
var Pager_1 = __importDefault(require("./Pager"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Filters_1 = require("./Filters");
var ItemTypes = { COLUMN: 'COLUMN' };
var ColumnSource = {
    beginDrag: function (_a) {
        var index = _a.index;
        return {
            index: index,
        };
    },
};
var ColumnTarget = {
    drop: function (props, monitor, component) {
        if (monitor.didDrop()) {
            return;
        }
        props.moveColumn({
            dragIndex: monitor.getItem().index,
            dropIndex: props.index,
        });
    },
};
var draggableColumn = react_dnd_1.DragSource(ItemTypes.COLUMN, ColumnSource, function (connect, monitor) { return ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}); });
var droppableColumn = react_dnd_1.DropTarget(ItemTypes.COLUMN, ColumnTarget, function (connect, monitor) { return ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }) && monitor.canDrop(),
}); });
var reverseOrder = function (order) { return (order === constants_1.Order.DESC ? constants_1.Order.ASC : constants_1.Order.DESC); };
var IconDown = function (_a) {
    var style = _a.style;
    return react_1.default.createElement(expand_more_1.default, { style: style });
};
var IconUp = function (_a) {
    var style = _a.style;
    return react_1.default.createElement(expand_less_1.default, { style: style });
};
var ColumnHeaderIcon = function (_a) {
    var order = _a.order, style = _a.style;
    return order === constants_1.Order.ASC ? react_1.default.createElement(IconUp, { style: style }) : react_1.default.createElement(IconDown, { style: style });
};
var ColumnGroupIcon = function (_a) {
    var styles = _a.styles, active = _a.active, handleGroup = _a.handleGroup;
    return (react_1.default.createElement("div", { style: styles.sortIconWrapper },
        react_1.default.createElement(storage_1.default, { style: active ? styles.sortIconSorted : styles.sortIcon, onClick: handleGroup })));
};
var ComposedColumnGroupIcon = recompose_1.compose(recompose_1.branch(function (_a) {
    var grouping = _a.grouping;
    return !grouping;
}, recompose_1.renderNothing), utils_1.withStyles, recompose_1.withProps(function (_a) {
    var group = _a.group, column = _a.column;
    return ({
        active: lodash_1.isEqual(group, column),
    });
}), recompose_1.withHandlers({
    handleGroup: function (_a) {
        var dispatch = _a.dispatch, active = _a.active, column = _a.column;
        return function () {
            dispatch(utils_2.createAction('GROUP', active ? undefined : column));
        };
    },
}))(ColumnGroupIcon);
var ColumnHeader = function (_a) {
    var sorting = _a.sorting, styles = _a.styles, sort = _a.sort, order = _a.order, column = _a.column, onColumnClick = _a.onColumnClick, connectDragSource = _a.connectDragSource, connectDropTarget = _a.connectDropTarget, headerOverStyle = _a.headerOverStyle, isOver = _a.isOver, index = _a.index, handleBorder = _a.handleBorder, isBorder = _a.isBorder, rest = __rest(_a, ["sorting", "styles", "sort", "order", "column", "onColumnClick", "connectDragSource", "connectDropTarget", "headerOverStyle", "isOver", "index", "handleBorder", "isBorder"]);
    var sorted = utils_1.isSorted(column, sort);
    var iconWrapperStyle = sorted ? {} : styles.hidden;
    var headerStyle = sorted ? styles.theadThSorted : {};
    var iconStyle = sorted ? styles.sortIconSorted : styles.sortIcon;
    var spanStyle = sorted ? styles.theadThSpanSorted : styles.theadThSpan;
    var overStyle = isOver ? headerOverStyle : undefined;
    var columnHeaderIcon = (react_1.default.createElement("div", { style: __assign({}, styles.sortIconWrapper, iconWrapperStyle) },
        react_1.default.createElement(ColumnHeaderIcon, { order: order, style: iconStyle })));
    return connectDragSource(connectDropTarget(react_1.default.createElement("th", { style: __assign({}, styles.theadTh, headerStyle, overStyle, { width: column.width, minWidth: column.width }, utils_1.cellStyle(styles, column), { borderBottom: "2px solid " + (isBorder ? 'transparent' : styles.theadTr.background) }), onClick: onColumnClick, onMouseOver: function () { return handleBorder(true); }, onMouseOut: function () { return handleBorder(false); } },
        react_1.default.createElement(ComposedColumnGroupIcon, __assign({}, rest, { column: column })),
        sorting && utils_1.cellAlign(styles, column) === 'right' && columnHeaderIcon,
        react_1.default.createElement("span", { style: spanStyle }, column.label),
        sorting && utils_1.cellAlign(styles, column) !== 'right' && columnHeaderIcon)));
};
var ColumnHeaderComposed = recompose_1.compose(recompose_1.pure, utils_1.withStyles, recompose_1.defaultProps({
    connectDragSource: lodash_1.identity,
    connectDropTarget: lodash_1.identity,
}), recompose_1.branch(function (_a) {
    var draggable = _a.draggable;
    return draggable;
}, droppableColumn), recompose_1.branch(function (_a) {
    var draggable = _a.draggable;
    return draggable;
}, draggableColumn), recompose_1.withState('isBorder', 'handleBorder', false), recompose_1.withHandlers({
    onColumnClick: function (_a) {
        var _b = _a.column, sortable = _b.sortable, columnRest = __rest(_b, ["sortable"]), order = _a.order, setOrder = _a.setOrder, sort = _a.sort, setSort = _a.setSort, sorting = _a.sorting, setFocusedField = _a.setFocusedField;
        return function () {
            if (sorting && sortable !== false) {
                var sorted = utils_1.isSorted(columnRest, sort);
                if (sorted) {
                    setOrder(reverseOrder(order));
                }
                else {
                    setSort(columnRest.field);
                }
                setFocusedField(undefined);
            }
        };
    },
}))(ColumnHeader);
var ColumnHeaderCheckbox = function (_a) {
    var styles = _a.styles, onCheck = _a.onCheck, items = _a.items, checkedItems = _a.checkedItems, showCheckboxes = _a.showCheckboxes;
    return (react_1.default.createElement("th", { style: __assign({}, styles.theadTh, { width: 40, textAlign: 'left', borderBottom: "2px solid " + styles.theadTr.background }) }, showCheckboxes && (react_1.default.createElement(Checkbox_1.default, { onChange: onCheck, uncheckColor: styles.theadCheckbox.uncheckColor, checkColor: styles.theadCheckbox.checkColor, value: lodash_1.differenceWith(items, checkedItems, lodash_1.isEqual).length === 0 }))));
};
var ColumnHeaderCheckboxComposed = recompose_1.compose(recompose_1.pure, utils_1.withStyles, recompose_1.withHandlers({
    onCheck: function (_a) {
        var items = _a.items, checkedItems = _a.checkedItems, dispatch = _a.dispatch;
        return function (value) {
            if (value) {
                dispatch(utils_2.createAction('CHECK', items));
            }
            else {
                dispatch(utils_2.createAction('CHECK', []));
            }
        };
    },
}))(ColumnHeaderCheckbox);
var FilterRowCell = function (_a) {
    var column = _a.column, styles = _a.styles, onFilterValueChange = _a.onFilterValueChange, changeFilterValueOnEnter = _a.changeFilterValueOnEnter, filters = _a.filters, booleanTranslation = _a.booleanTranslation, filterRowDateFromPlaceholder = _a.filterRowDateFromPlaceholder, filterRowDateToPlaceholder = _a.filterRowDateToPlaceholder, locale = _a.locale, loading = _a.loading, setFocusedField = _a.setFocusedField, focusedField = _a.focusedField, openedFilters = _a.openedFilters, openFiltersOnFilterRowChange = _a.openFiltersOnFilterRowChange, dateTimeInISO = _a.dateTimeInISO;
    var field = column.field;
    var disabled = loading || (!openFiltersOnFilterRowChange && openedFilters);
    // matus: DATE and DATETIME fields need two separate filters
    if (column.type === constants_1.ColumnType.DATE ||
        column.type === constants_1.ColumnType.DATETIME ||
        column.type === constants_1.ColumnType.DATETIMEWITHOUTZONE) {
        var filterBefore = filters.find(function (filter) { return filter.field === field && filter.operation === constants_1.FilterOperation.LTE; }) || {
            operation: constants_1.FilterOperation.LTE,
            field: field,
        };
        var filterAfter = filters.find(function (filter) { return filter.field === field && filter.operation === constants_1.FilterOperation.GTE; }) || {
            operation: constants_1.FilterOperation.GTE,
            field: field,
        };
        return (react_1.default.createElement("th", { style: __assign({}, styles.theadTh, utils_1.cellStyle(styles, column)) },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: column.align === 'left' ? 'flex-start' : 'flex-end',
                } },
                react_1.default.createElement(Filters_1.FilterValue, { style: __assign({}, styles.filterRowValue, { flex: 1 }), wrapperStyle: column.compact ? { maxWidth: '48px' } : { width: 'auto', minWidth: 100 }, filter: filterAfter, column: column, placeholder: filterRowDateFromPlaceholder, onFilterValueChange: onFilterValueChange(filterAfter), locale: locale, disabled: disabled, focusedField: focusedField, setFocusedField: setFocusedField, changeFilterValueOnEnter: changeFilterValueOnEnter, dateTimeInISO: dateTimeInISO, id: "uas-web-core-grid-filter-from-" + field }),
                react_1.default.createElement("span", { style: { lineHeight: '48px' } }, " \u2014 "),
                react_1.default.createElement(Filters_1.FilterValue, { style: __assign({}, styles.filterRowValue, { flex: 1 }), wrapperStyle: column.compact ? { maxWidth: '48px' } : { width: 'auto', minWidth: 100 }, filter: filterBefore, column: column, placeholder: filterRowDateToPlaceholder, onFilterValueChange: onFilterValueChange(filterBefore), locale: locale, disabled: disabled, focusedField: focusedField, setFocusedField: setFocusedField, changeFilterValueOnEnter: changeFilterValueOnEnter, dateTimeInISO: dateTimeInISO, id: "uas-web-core-grid-filter-to-" + field }))));
    }
    else {
        var filter = filters.find(function (filter) {
            return filter.field === field &&
                filter.operation !== constants_1.FilterOperation.IS_NULL &&
                filter.operation !== constants_1.FilterOperation.NOT_NULL;
        }) || {
            operation: column.defaultOperation || constants_1.defaultFilterOperation[column.type],
            field: field,
        };
        // TODO refactor onFilterValueChange(filter) to  onFilterValueChange
        return (react_1.default.createElement("th", { style: __assign({}, styles.theadTh, utils_1.cellStyle(styles, column)) },
            react_1.default.createElement(Filters_1.FilterValue, { style: __assign({}, styles.filterRowValue, { width: column.width }), inputStyle: column.type === constants_1.ColumnType.NUMBER ? { textAlign: column.align ? column.align : 'right' } : null, filter: filter, column: column, booleanTranslation: booleanTranslation, onFilterValueChange: onFilterValueChange(filter), changeFilterValueOnEnter: changeFilterValueOnEnter, locale: locale, disabled: disabled, focusedField: focusedField, setFocusedField: setFocusedField })));
    }
};
var ComposedFilterRowCell = recompose_1.compose(utils_1.withStyles, recompose_1.withHandlers({
    onFilterValueChange: lodash_1.curry(function (_a, filter, value) {
        var filters = _a.filters, setFilters = _a.setFilters, setFiltersOpen = _a.setFiltersOpen, openFiltersOnFilterRowChange = _a.openFiltersOnFilterRowChange;
        var newFilter = __assign({}, filter, { value: value });
        var newFilters = filters.find(function (f) { return f.field === filter.field && f.operation === filter.operation; })
            ? value === '' || value === undefined || value === null
                ? filters.filter(function (f) { return f.field !== filter.field || f.operation !== filter.operation; }) // delete filter
                : utils_1.replace(filters, filter, newFilter)
            : __spread(filters, [newFilter]);
        if (openFiltersOnFilterRowChange) {
            if (!lodash_1.isEmpty(newFilters)) {
                setFiltersOpen(true);
            }
            else if (lodash_1.isEmpty(newFilters)) {
                setFiltersOpen(false);
            }
        }
        setFilters(newFilters);
    }),
}))(FilterRowCell);
var Head = function (_a) {
    var paging = _a.paging, filterRow = _a.filterRow, showHeadPager = _a.showHeadPager, columns = _a.columns, styles = _a.styles, onRemoveAllFiltersClick = _a.onRemoveAllFiltersClick, deleteFiltersTooltip = _a.deleteFiltersTooltip, deleteFiltersIcon = _a.deleteFiltersIcon, rest = __rest(_a, ["paging", "filterRow", "showHeadPager", "columns", "styles", "onRemoveAllFiltersClick", "deleteFiltersTooltip", "deleteFiltersIcon"]);
    return (react_1.default.createElement("thead", null,
        paging && showHeadPager && react_1.default.createElement(Pager_1.default, __assign({ columns: columns }, rest)),
        react_1.default.createElement("tr", { style: styles.theadTr },
            (filterRow || rest.showCheckboxes) && react_1.default.createElement(ColumnHeaderCheckboxComposed, __assign({}, rest)),
            columns
                .filter(function (c) { return c.visible !== false; })
                .map(function (column, i) { return (react_1.default.createElement(ColumnHeaderComposed, __assign({ key: i, index: i }, rest, { column: column }))); })),
        filterRow && (react_1.default.createElement("tr", { style: styles.theadTr && styles.filterGridRow },
            react_1.default.createElement("th", { style: {
                    width: 40,
                    textAlign: 'left',
                    paddingLeft: 10,
                    paddingRight: 10,
                } },
                react_1.default.createElement(IconButton_1.default, { style: { marginLeft: -10 }, onClick: onRemoveAllFiltersClick, tooltip: deleteFiltersTooltip, tooltipPosition: "top-right", touch: true }, deleteFiltersIcon)),
            columns
                .filter(function (c) { return c.visible !== false; })
                .map(function (column, i) { return (react_1.default.createElement(ComposedFilterRowCell, __assign({ key: i }, rest, { column: column }))); })))));
};
exports.default = recompose_1.compose(utils_1.withStyles, recompose_1.withState('focusedField', 'setFocusedField', undefined), recompose_1.withHandlers({
    onRemoveAllFiltersClick: function (_a) {
        var defaultSort = _a.defaultSort, defaultFilter = _a.defaultFilter, setSort = _a.setSort, setFilters = _a.setFilters, resetSettings = _a.resetSettings, onRemoveAllFilters = _a.onRemoveAllFilters, resetSettingsOnRemoveAllFilters = _a.resetSettingsOnRemoveAllFilters;
        return function () {
            onRemoveAllFilters();
            if (typeof defaultSort !== 'undefined') {
                setSort(defaultSort);
            }
            if (typeof defaultFilter !== 'undefined') {
                setFilters(defaultFilter);
            }
            else {
                setFilters([]);
            }
            if (resetSettingsOnRemoveAllFilters) {
                resetSettings();
            }
        };
    },
}), recompose_1.mapProps(function (_a) {
    var onRemoveAllFilters = _a.onRemoveAllFilters, rest = __rest(_a, ["onRemoveAllFilters"]);
    return rest;
}))(Head);
//# sourceMappingURL=Header.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Header.js
// module id = 2115
// module chunks = 0